import {
  ActionList,
  Badge,
  Button,
  Card,
  Divider,
  Icon,
  LegacyCard,
  Popover,
  Text,
} from "@shopify/polaris"
import {
  MagicIcon,
  PackageReturnedIcon,
  ReplaceIcon,
  ShippingLabelIcon,
} from "@shopify/polaris-icons"
import { observer } from "mobx-react"
import { MenuHorizontalIcon, XIcon } from "polaris-enhance"
import { Fragment, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

import stores from "@/stores"

const RecommendForYouCard = () => {
  const history = useHistory()
  const { ReturnRequestsDataStore, UserInfoStore } = stores
  const [popoverActive, setPopoverActive] = useState(false)

  const {
    exchange_open,
    shipping_method_open,
    start_recharge,
    work_flow_enable,
    show_index_recommend,
  } = ReturnRequestsDataStore.index_recommend ?? {}

  const { finish_task_count, should_finish_task_count } =
    UserInfoStore.guideData
  const isGuideAllComplete =
    should_finish_task_count > 0 &&
    finish_task_count >= should_finish_task_count

  const items = [
    {
      key: "exchange",
      show: exchange_open,
      icon: ReplaceIcon,
      title: t("OfferExchangesAsAnOption"),
      description: t("LetCustomersChooseAnotherItemInsteadOfRefund"),
      buttonText: t("EnableNow"),
      onAction: () => {
        history.push("/settings/solutions", { focus: "return_solutions" })
      },
    },
    {
      key: "shipping",
      show: shipping_method_open,
      icon: PackageReturnedIcon,
      title: t("SetUpReturnShippingMethods"),
      description: t("GiveCustomersMoreWaysToSendItemsBack"),
      buttonText: t("SetItUp"),
      onAction: () => {
        history.push("/settings/shipping-method", { focus: "shipping_methods" })
      },
    },
    {
      key: "recharge",
      show: start_recharge,
      icon: ShippingLabelIcon,
      title: t("CreateReturnLabelsWithParcelWILLCarrier"),
      description: t("UseOurBuiltInCarrierServiceToCreateLabels"),
      buttonText: t("EnableNow"),
      onAction: () => {
        history.push("/settings/logistics-integration")
      },
    },
    {
      key: "workflow",
      show: work_flow_enable,
      icon: MagicIcon,
      title: t("AutomateReturnWorkflows"),
      description: t("AutoApproveOrRefundEligibleReturnsByRules"),
      buttonText: t("SetItUp"),
      onAction: () => {
        history.push("/settings/automation")
      },
    },
  ].filter((item) => item.show)

  // @todo 等后端补充字段
  // const notDismissed = UserInfoStore.showBanner?.show_recommend_for_you === 1
  const notDismissed = true
  if (
    !isGuideAllComplete ||
    !notDismissed ||
    items.length === 0 ||
    !show_index_recommend
  ) {
    return null
  }

  return (
    <Card>
      <div className="flex items-start justify-between gap-2">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <Text variant="headingSm" as="h2">
              {t("RecommendedForYou")}
            </Text>
            <Badge tone="info">{t("New")}</Badge>
          </div>
          <Text variant="bodyMd" as="p" tone="subdued">
            {t("PopularSettingsAmongSimilarStores")}
          </Text>
        </div>
        <Popover
          active={popoverActive}
          activator={
            <Button
              variant="tertiary"
              icon={MenuHorizontalIcon}
              onClick={() => setPopoverActive((prev) => !prev)}
            />
          }
          onClose={() => setPopoverActive(false)}
        >
          <ActionList
            actionRole="menuitem"
            items={[
              {
                content: t("Dismiss"),
                icon: XIcon,
                onAction: () => {
                  setPopoverActive(false)
                  UserInfoStore.closeBanner(27, "show_recommend_for_you")
                  // 设置show_index_recommend为flse
                  ReturnRequestsDataStore.setShowIndexRecommend(false)
                },
              },
            ]}
          />
        </Popover>
      </div>

      <div className="mt-4 flex flex-col gap-2">
        {items.map((item, index) => (
          <Fragment key={item.key}>
            {index > 0 && <Divider />}
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-2">
                <div className="flex size-7 shrink-0 items-center justify-center rounded-lg bg-[#f1f1f1]">
                  <div className="size-5">
                    <Icon source={item.icon} tone="base" />
                  </div>
                </div>
                <div>
                  <Text variant="bodyMd" fontWeight="semibold" as="h3">
                    {item.title}
                  </Text>
                  <Text variant="bodyMd" as="p" tone="subdued">
                    {item.description}
                  </Text>
                </div>
              </div>
              <div className="shrink-0">
                <Button size="slim" onClick={item.onAction}>
                  {item.buttonText}
                </Button>
              </div>
            </div>
          </Fragment>
        ))}
      </div>
    </Card>
  )
}

export default observer(RecommendForYouCard)
